export const primaryColor = 'var(--primary-color)';
export const secondaryColor = 'var(--secondary-color)';
export const borderRadius = 'var(--input-borderRadius)';
